import { CategoryRowActions } from 'modules/inventory/settings/category/components/CategoryRowActions';
import { CellAlign, HeadCell } from '@dfl/mui-admin-layout';
import { ICategory } from 'modules/inventory/settings/category/interfaces';
import { createdATColumn } from 'modules/common/constants/common.columns';
import { CATEGORY_PERMISSIONS } from 'modules/inventory/settings/category/constants/category.permissions';
import { CategoryVisiblePicker } from 'modules/inventory/settings/category/components/CategoryVisiblePicker';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import { LongText } from '@dfl/mui-react-common';
import { AvatarMedia } from 'components/AvatarMedia';
import { Image } from '@mui/icons-material';
import { CategoryStoreLinkCell } from 'modules/inventory/settings/category/components/CategoryStoreLinkCell';

export const categoryNameColumn: HeadCell<ICategory> = {
  field: 'name',
  headerName: 'category:fields.name',
  width: 300,
  renderCell: (name: string, data: ICategory) => (
    <AvatarNameCell
      link={`/inventory/settings/categories/${data._id as string}/subcategories`}
      name={data.name}
      variant={'rounded'}
      image={data.image}
      permissions={[CATEGORY_PERMISSIONS.CATEGORY_VIEW]}
    />
  ),
};
export const categoryBannerColumn: HeadCell<ICategory> = {
  field: 'banner',
  headerName: 'category:fields.banner',
  sortable: false,
  renderCell: (_, data: ICategory) => (
    <AvatarMedia name={`banner-${data?._id as string}`} avatar={data?.banner} variant={'rounded'}>
      {<Image fontSize='small' />}
    </AvatarMedia>
  ),
};

export const categoryDescriptionColumn: HeadCell<ICategory> = {
  field: 'description',
  headerName: 'category:fields.description',
  renderCell: (description: string) => <LongText text={description} lineClamp={2} />,
  width: 300,
  sortable: false,
};

export const categoryVisibilityColumn: HeadCell<ICategory> = {
  field: 'visible',
  align: CellAlign.CENTER,
  headerName: 'category:fields.visibility',
  component: CategoryVisiblePicker,
  sortable: false,
};
export const categoryPriorityColumn: HeadCell<ICategory> = {
  field: 'order',
  align: CellAlign.CENTER,
  headerName: 'category:fields.order',
  renderCell: (order: number) => order,
  headerAlign: CellAlign.CENTER,
  sortable: false,
};

export const categoryStoreLinkColumn: HeadCell<ICategory> = {
  field: 'slug',
  headerName: 'category:fields.storeLink',
  sortable: false,
  width: 320,
  renderCell: (_, data: ICategory) => <CategoryStoreLinkCell category={data} />,
};

export const categoryActionsColumn: HeadCell<ICategory> = {
  field: 'actions',
  sortable: false,
  width: 160,
  align: CellAlign.CENTER,
  permissions: CATEGORY_PERMISSIONS.CATEGORY_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: CategoryRowActions,
};

const categoryCreatedAtColumn = {
  ...createdATColumn,
  sortable: false,
};

export const categoryColumns: Array<HeadCell<any>> = [
  categoryNameColumn,
  // categoryBannerColumn,
  // categoryPriorityColumn,
  categoryDescriptionColumn,
  categoryStoreLinkColumn,
  categoryVisibilityColumn,
  categoryCreatedAtColumn,
  categoryActionsColumn,
];
